/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Period_WeekInputs */

const en_plan_period_week = /** @type {(inputs: Plan_Period_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`week`)
};

const es_plan_period_week = /** @type {(inputs: Plan_Period_WeekInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`semana`)
};

/**
* | output |
* | --- |
* | "week" |
*
* @param {Plan_Period_WeekInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_period_week = /** @type {((inputs?: Plan_Period_WeekInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Period_WeekInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_period_week(inputs)
	return en_plan_period_week(inputs)
});